import { useRootSelector } from '../../../../../store/hooks';
import { selectSiteHeader } from '../../../../../store/features/siteHeader';
import SiteHeader from '../../../../styled/siteLayout/SiteHeader';

export default function Header() {
  const siteHeader = useRootSelector(selectSiteHeader);

  return <SiteHeader siteHeader={siteHeader} />;
}
